(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/utils/eurojackpot-rule-change.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/utils/eurojackpot-rule-change.js');
"use strict";


let getRuleChange;
let productMapping;

function isNewRules() {
  var _getRuleChange;
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    product = _ref.product,
    drawNumber = _ref.drawNumber;
  if (!product || !drawNumber) {
    return false;
  }
  const productItsId = productMapping.getProductItsId(product);
  if (!productMapping.isEurojackpot(productItsId)) {
    return false;
  }
  const firstNewDraw = (_getRuleChange = getRuleChange()) === null || _getRuleChange === void 0 ? void 0 : _getRuleChange[productItsId];
  const currentDraw = Number(drawNumber);
  if (!Number.isSafeInteger(firstNewDraw) || firstNewDraw < 1 || !Number.isSafeInteger(currentDraw) || currentDraw < 1) {
    return false;
  }
  return currentDraw >= firstNewDraw;
}
if (svs.isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  var _trinidadCore$compone = trinidadCore.components.require('numbergames', 'product-mapping');
  productMapping = _trinidadCore$compone.productMapping;
  getRuleChange = () => {
    var _trinidadCore$config$;
    return (_trinidadCore$config$ = trinidadCore.config.options.cms) === null || _trinidadCore$config$ === void 0 || (_trinidadCore$config$ = _trinidadCore$config$.numbergames) === null || _trinidadCore$config$ === void 0 || (_trinidadCore$config$ = _trinidadCore$config$.eurojackpot) === null || _trinidadCore$config$ === void 0 ? void 0 : _trinidadCore$config$.ruleChange;
  };
  module.exports = {
    isNewRules
  };
} else {
  productMapping = svs.numbergames.productMapping;
  getRuleChange = () => {
    var _svs$numbergames$rule;
    return (_svs$numbergames$rule = svs.numbergames.rules.data) === null || _svs$numbergames$rule === void 0 || (_svs$numbergames$rule = _svs$numbergames$rule.config) === null || _svs$numbergames$rule === void 0 || (_svs$numbergames$rule = _svs$numbergames$rule.eurojackpot) === null || _svs$numbergames$rule === void 0 ? void 0 : _svs$numbergames$rule.ruleChange;
  };
  svs.numbergames.rules.utils.eurojackpotRuleChange = {
    isNewRules
  };
}

 })(window);